import "./App.css"

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"

import HomePage from "./pages/home/HomePage"
import LoginPage from "./pages/home/LoginPage"
import SignUp from "./pages/home/RegisterPage"
import ForgotPassword from "./pages/home/ForgetPasswordPage"
import VerifyCodePage from "./pages/home/ResetCodePage"
import ResetPassword from "./pages/home/ResetPasswordPage"


import NotFound from "./pages/home/NotFound"
import Contact from "./pages/home/Contact"

import About from "./pages/home/About"
import Activity from "./pages/home/Activity"
import Blog from "./pages/home/Blog"
import Blogs from "./pages/home/Blogs"
import Countries from "./pages/home/Countries"
import Country from "./pages/home/Country"
import Club from "./pages/home/Club"
import Departments from "./pages/home/Departments"
import Department from "./pages/home/Department"
import Program from "./pages/home/Program"
import Programs from "./pages/home/Programs"
import Projects from "./pages/home/Projects"
import Project from "./pages/home/Project"
import Researches from "./pages/home/Researches"
import Research from "./pages/home/Research"
import Branch from "./pages/home/Branch"
import Jobs from "./pages/home/Jobs"
import Job from "./pages/home/Job"

import Profile from "./pages/users/Profile"
import Chat from "./pages/users/Chat"

import DataForm from "./pages/home/DataForm"
import DataFormViewer from "./pages/home/DataFormViewer"
import DataFormAnswer from "./pages/home/DataFormAnswer"

import ProtectedRoute from './routes/ProtectedRoute'

function App() {

  return (
    <Router>
      <Routes>
        <Route exact path='/' element={<HomePage />} />
        <Route exact path='/contact' element={<Contact />} />
      
        <Route path='/login' element={<LoginPage />} />
        <Route path='/register' element={<SignUp />} />
        <Route path='/reset_password' element={<ResetPassword />} />
        <Route path='/forgot_password' element={<ForgotPassword />} />
        <Route path='/verify_code' element={<VerifyCodePage />} />

        <Route path='/emy_form' element={<DataForm />} />
        {/* <Route path='/emyform' element={<DataFormViewer />} /> */}
        <Route path="/emyform/:formId" element={<DataFormViewer />} />
        <Route path="/emyformanswer/:formId" element={<DataFormAnswer />} />

        <Route path='/profile' element={<Profile />} />
        <Route path='/chat' element={<Chat />} />
        
        <Route path='/jobs' element={<Jobs />} />
        <Route path='/job' element={<Job />} />
        <Route path='/branch' element={<Branch />} />
        <Route path='/about' element={<About />} />
        <Route path='/blog' element={<Blog />} />
        <Route path='/blogs' element={<Blogs />} />
        <Route path='/countries' element={<Countries />} />
        <Route path='/country' element={<Country />} />
        <Route path='/club' element={<Club />} />
        <Route path='/departments' element={<Departments />} />
        <Route path='/department' element={<Department />} />
        <Route path='/program' element={<Program />} />
        <Route path='/programs' element={<Programs />} />
        <Route path='/projects' element={<Projects />} />
        <Route path='/project' element={<Project />} />
        <Route path='/researches' element={<Researches />} />
        <Route path='/research' element={<Research />} />

        
        <Route element={<ProtectedRoute />}>
          <Route path='/activity' element={<Activity />} />
        

        </Route>
        
        <Route path="*" element={<NotFound/>} />

      </Routes>
    </Router>
  );
}

export default App
